(function () {
  // Overlay prev/next arrows on the main product image so clicking an arrow
  // swaps the big image to the next / previous media — mirroring the card
  // carousel on the product grid. Navigation is driven through the existing
  // <media-gallery> element's setActiveMedia(), so thumbnails, variant images
  // and the "don't scroll the page" behaviour all keep working.
  var CARET =
    '<svg viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"/>' +
    '</svg>';

  function initGallery(gallery) {
    if (gallery.__mediaArrowsInit) return;
    // The "columns" layout shows every image at once in a grid, so there is
    // no active image to page through.
    if (gallery.dataset.desktopLayout === 'columns') return;
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;
    var list = viewer.querySelector('.product__media-list');
    if (!list) return;
    var items = Array.prototype.slice.call(list.querySelectorAll('.product__media-item[data-media-id]'));
    if (items.length < 2) return;
    gallery.__mediaArrowsInit = true;

    var arrows = document.createElement('div');
    arrows.className = 'product__media-arrows';
    arrows.innerHTML =
      '<button type="button" class="product__media-arrow product__media-arrow--prev" aria-label="Previous image">' +
      '<span class="svg-wrapper">' + CARET + '</span></button>' +
      '<button type="button" class="product__media-arrow product__media-arrow--next" aria-label="Next image">' +
      '<span class="svg-wrapper">' + CARET + '</span></button>';
    viewer.appendChild(arrows);

    function currentIndex() {
      for (var i = 0; i < items.length; i++) {
        if (items[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    function go(dir) {
      var idx = (currentIndex() + dir + items.length) % items.length;
      var id = items[idx].dataset.mediaId;
      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(id, false);
      } else {
        var thumb = gallery.querySelector('[data-target="' + id + '"] button');
        if (thumb) thumb.click();
      }
    }

    arrows.querySelector('.product__media-arrow--prev').addEventListener('click', function (e) {
      e.preventDefault();
      go(-1);
    });
    arrows.querySelector('.product__media-arrow--next').addEventListener('click', function (e) {
      e.preventDefault();
      go(1);
    });
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(initGallery);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
